import React, { useEffect, useState } from 'react';
import { ArrowRightIcon, ZapIcon } from 'lucide-react';
import { trackPurchaseClick, trackSectionView, trackContentEngagement } from './MetaPixelTracker';
export function CTASection() {
  const [selectedOption, setSelectedOption] = useState('option2'); // Default to option2 (74.990)
  useEffect(() => {
    // Track section view when component mounts
    trackSectionView('CTASection');
  }, []);
  const handleOptionChange = (option: string, trackingLabel: string) => {
    setSelectedOption(option);
    trackContentEngagement('pricing', trackingLabel, 'select');
  };
  return <section className="py-16 border-b border-gray-800" data-id="element-20">
      <div className="max-w-3xl mx-auto" data-id="element-21">
        <h2 className="text-3xl font-bold mb-8 text-center" data-id="element-22">
          <span className="bg-gradient-to-r from-red-500 to-orange-500 text-transparent bg-clip-text" data-id="element-23">
            No llegaste hasta acá por casualidad.
          </span>
        </h2>
        <div className="text-center space-y-6 mb-10" data-id="element-24">
          <p className="text-lg" data-id="element-25">
            Algo dentro tuyo ya lo sabía. Tu mente consciente… solo esperaba una
            señal.
          </p>
          <p className="text-xl font-bold" data-id="element-26">Y esta… es esa señal.</p>
        </div>
        <div className="space-y-6 mb-12 max-w-md mx-auto" data-id="element-27"></div>
        <div className="text-center space-y-6 mb-10" data-id="element-28">
          <p className="text-lg" data-id="element-29">
            Y mientras lo hacés… notá cómo algo en vos ya empezó a cambiar.
          </p>
          <p className="text-lg" data-id="element-30">Sin darte cuenta, ya decidiste.</p>
          <div className="my-8" data-id="element-31">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wxw71WrxTuMXEY7BGHLHZM/Generated_image_1_%281%29.png" alt="ImpulseX con Juegos de Poder" className="rounded-lg shadow-lg w-64 h-64 object-cover object-center mx-auto" onClick={() => trackContentEngagement('image', 'juegos_de_poder', 'click')} data-id="element-32" />
          </div>
          <p className="text-xl font-bold text-red-500" data-id="element-33">
            Ahora… solo hacelo real.
          </p>
          <p className="text-lg mt-6" data-id="element-34">
            Y cuando te mires al espejo después de probarlo… vas a recordar este
            momento. Porque fue hoy. Fue ahora. Donde todo empezó a cambiar.
          </p>
          <div className="max-w-md mx-auto mt-8" data-id="element-35">
            <div className={`bg-black border ${selectedOption === 'option1' ? 'border-red-600 border-2' : 'border-red-600'} rounded-xl p-4 relative transition-all`} data-id="element-36">
              <div className="bg-green-500 text-black font-bold text-xs uppercase py-1 px-3 rounded-full absolute -top-2 left-4" data-id="element-37">
                ENVIO GRATIS 5 DIAS
              </div>
              <div className="flex items-center justify-between" data-id="element-38">
                <div className="flex items-center gap-3" data-id="element-39">
                  <input type="radio" id="option1" name="pricing_option" className="w-5 h-5 accent-red-600" checked={selectedOption === 'option1'} onChange={() => handleOptionChange('option1', 'monthly_subscription')} data-id="element-40" />
                  <div className="w-10 h-10 bg-red-600/20 rounded-full flex items-center justify-center" data-id="element-41">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kjGsWHLpmc4fptYLDXS7un/IMG_4332-removebg-preview.png" alt="ImpulseX Bottle" className="w-6 h-6 object-contain" data-id="element-42" />
                  </div>
                  <div data-id="element-43">
                    <p className="font-bold text-white" data-id="element-44">1 BOTELLA</p>
                  </div>
                </div>
                <div className="text-right" data-id="element-45">
                  <p className="font-bold text-2xl text-white" data-id="element-46">$39.990</p>
                  <p className="text-xs text-gray-400" data-id="element-47">
                    <span className="line-through" data-id="element-48">65.000</span> ahorra 38.5%
                  </p>
                </div>
              </div>
              {selectedOption === 'option1' && <div className="mt-4" data-id="element-49">
                  <a href="https://impulseexar.myshopify.com/cart/46748096954596:1" className="bg-gradient-to-r from-red-500 to-orange-500 text-white py-2 px-6 rounded-full flex items-center justify-center gap-2 hover:from-red-600 hover:to-orange-600 transition-all shadow-lg w-full font-bold" onClick={() => {
                trackPurchaseClick('Option1_PayNow_Button');
                // Enhanced tracking for better conversion tracking
                if (window.fbq) {
                  window.fbq('track', 'AddToCart', {
                    content_name: 'ImpulseX 30ML - 1 Botella',
                    content_category: 'Activación Masculina',
                    content_ids: ['IMPULSEX30-1'],
                    content_type: 'product',
                    value: 44990,
                    currency: 'CLP'
                  });
                }
              }} data-id="element-50">
                    PAGAR AHORA <ArrowRightIcon className="h-4 w-4" data-id="element-51" />
                  </a>
                </div>}
            </div>
            <div className={`bg-black border ${selectedOption === 'option2' ? 'border-red-600 border-2' : 'border-red-600'} rounded-xl p-4 relative mt-4 transition-all`} data-id="element-52">
              <div className="bg-green-500 text-black font-bold text-xs uppercase py-1 px-3 rounded-full absolute -top-2 left-4" data-id="element-53">
                ENVIO GRATIS 2 DIAS + EBOOK DE REGALO
              </div>
              <div className="flex items-center justify-between" data-id="element-54">
                <div className="flex items-center gap-3" data-id="element-55">
                  <input type="radio" id="option2" name="pricing_option" className="w-5 h-5 accent-red-600" checked={selectedOption === 'option2'} onChange={() => handleOptionChange('option2', 'double_bottle_subscription')} data-id="element-56" />
                  <div className="w-10 h-10 bg-red-600/20 rounded-full flex items-center justify-center" data-id="element-57">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kjGsWHLpmc4fptYLDXS7un/IMG_4332-removebg-preview.png" alt="ImpulseX Bottle" className="w-6 h-6 object-contain" data-id="element-58" />
                  </div>
                  <div data-id="element-59">
                    <p className="font-bold text-white" data-id="element-60">2 BOTELLAS</p>
                  </div>
                </div>
                <div className="text-right" data-id="element-61">
                  <p className="font-bold text-2xl text-white" data-id="element-62">$59.990</p>
                  <p className="text-xs text-gray-400" data-id="element-63">
                    <span className="line-through" data-id="element-64">120.000</span> ahorra 50.5%
                  </p>
                </div>
              </div>
              {selectedOption === 'option2' && <div className="mt-4" data-id="element-65">
                  <a href="https://impulseexar.myshopify.com/cart/46753780465892:1" className="bg-gradient-to-r from-red-500 to-orange-500 text-white py-2 px-6 rounded-full flex items-center justify-center gap-2 hover:from-red-600 hover:to-orange-600 transition-all shadow-lg w-full font-bold" onClick={() => {
                trackPurchaseClick('Option2_PayNow_Button');
                // Enhanced tracking for better conversion tracking
                if (window.fbq) {
                  window.fbq('track', 'AddToCart', {
                    content_name: 'ImpulseX 30ML - 2 Botellas',
                    content_category: 'Activación Masculina',
                    content_ids: ['IMPULSEX30-2'],
                    content_type: 'product',
                    value: 74990,
                    currency: 'CLP'
                  });
                }
              }} data-id="element-66">
                    PAGAR AHORA <ArrowRightIcon className="h-4 w-4" data-id="element-67" />
                  </a>
                </div>}
            </div>
          </div>
        </div>
        <div className="flex flex-col items-center mt-10" data-id="element-68"></div>
        <div className="flex justify-center mt-10" data-id="element-69">
          <div className="w-full" data-id="element-70">
            <h3 className="text-2xl font-bold mb-8 text-center" id="testimonials-section" data-id="element-71">
              <span className="bg-gradient-to-r from-red-500 to-orange-500 text-transparent bg-clip-text flex items-center justify-center" data-id="element-72">
                🗣️ Testimonios Reales de nuestros clientes
              </span>
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-73">
              <div className="bg-gray-900 p-5 rounded-lg border border-gray-800" onClick={() => trackContentEngagement('testimonial', 'lucas_m', 'click')} data-id="element-74">
                <p className="text-gray-300 italic mb-4" data-id="element-75">
                  "Lo empecé sin muchas expectativas... y a la semana, sentí la
                  diferencia. Más energía al entrenar, y en la intimidad... otra
                  historia. Me devolvió algo que pensé que había perdido."
                </p>
                <div className="flex items-center" data-id="element-76">
                  <div className="mr-3" data-id="element-77">
                    <img src="https://images.unsplash.com/photo-1528892952291-009c663ce843?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=100&q=80" alt="Lucas M." className="h-10 w-10 rounded-full object-cover" data-id="element-78" />
                  </div>
                  <div data-id="element-79">
                    <p className="font-medium text-white" data-id="element-80">Lucas M.</p>
                    <p className="text-sm text-gray-400" data-id="element-81">38 años, Rosario</p>
                  </div>
                </div>
              </div>
              <div className="bg-gray-900 p-5 rounded-lg border border-gray-800" onClick={() => trackContentEngagement('testimonial', 'andres_g', 'click')} data-id="element-82">
                <p className="text-gray-300 italic mb-4" data-id="element-83">
                  "ImpulseX no es como otros productos que probé. Esto se nota
                  en el cuerpo, pero también en la mente. Me levanto con más
                  foco, más motivación. Es como si algo se activara de nuevo."
                </p>
                <div className="flex items-center" data-id="element-84">
                  <div className="mr-3" data-id="element-85">
                    <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=100&q=80" alt="Andrés G." className="h-10 w-10 rounded-full object-cover" data-id="element-86" />
                  </div>
                  <div data-id="element-87">
                    <p className="font-medium text-white" data-id="element-88">Andrés G.</p>
                    <p className="text-sm text-gray-400" data-id="element-89">
                      45 años, Buenos Aires
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-gray-900 p-5 rounded-lg border border-gray-800" onClick={() => trackContentEngagement('testimonial', 'nicolas_t', 'click')} data-id="element-90">
                <p className="text-gray-300 italic mb-4" data-id="element-91">
                  "Siempre fui escéptico con estas cosas... pero con este
                  suplemento me sorprendí. La libido volvió a niveles de cuando
                  tenía 20. Y lo mejor: sin efectos raros."
                </p>
                <div className="flex items-center" data-id="element-92">
                  <div className="mr-3" data-id="element-93">
                    <img src="https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=100&q=80" alt="Nicolás T." className="h-10 w-10 rounded-full object-cover" data-id="element-94" />
                  </div>
                  <div data-id="element-95">
                    <p className="font-medium text-white" data-id="element-96">Nicolás T.</p>
                    <p className="text-sm text-gray-400" data-id="element-97">33 años, Córdoba</p>
                  </div>
                </div>
              </div>
              <div className="bg-gray-900 p-5 rounded-lg border border-gray-800" onClick={() => trackContentEngagement('testimonial', 'ezequiel_r', 'click')} data-id="element-98">
                <p className="text-gray-300 italic mb-4" data-id="element-99">
                  "No lo uso por estética, sino por conexión. Me ayudó a
                  sentirme más presente, más fuerte desde adentro. Se transformó
                  en parte de mi rutina diaria."
                </p>
                <div className="flex items-center" data-id="element-100">
                  <div className="mr-3" data-id="element-101">
                    <img src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=100&q=80" alt="Ezequiel R." className="h-10 w-10 rounded-full object-cover" data-id="element-102" />
                  </div>
                  <div data-id="element-103">
                    <p className="font-medium text-white" data-id="element-104">Ezequiel R.</p>
                    <p className="text-sm text-gray-400" data-id="element-105">41 años, Mendoza</p>
                  </div>
                </div>
              </div>
              <div className="bg-gray-900 p-5 rounded-lg border border-gray-800" onClick={() => trackContentEngagement('testimonial', 'cristian_p', 'click')} data-id="element-106">
                <p className="text-gray-300 italic mb-4" data-id="element-107">
                  "Siento que tengo el doble de energía durante el día, pero sin
                  ansiedad. En la noche, sigo con fuerza. Lo recomiendo porque
                  funciona sin vueltas."
                </p>
                <div className="flex items-center" data-id="element-108">
                  <div className="mr-3" data-id="element-109">
                    <img src="https://images.unsplash.com/photo-1568602471122-7832951cc4c5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=100&q=80" alt="Cristian P." className="h-10 w-10 rounded-full object-cover" data-id="element-110" />
                  </div>
                  <div data-id="element-111">
                    <p className="font-medium text-white" data-id="element-112">Cristian P.</p>
                    <p className="text-sm text-gray-400" data-id="element-113">
                      36 años, Mar del Plata
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-gray-900 p-5 rounded-lg border border-gray-800" onClick={() => trackContentEngagement('testimonial', 'matias_d', 'click')} data-id="element-114">
                <p className="text-gray-300 italic mb-4" data-id="element-115">
                  "Me costaba mucho mantener el deseo... y eso afectaba mi
                  relación. Desde que empecé con ImpulseX, todo cambió. Me
                  siento más hombre, más conectado, más seguro."
                </p>
                <div className="flex items-center" data-id="element-116">
                  <div className="mr-3" data-id="element-117">
                    <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=100&q=80" alt="Matías D." className="h-10 w-10 rounded-full object-cover" data-id="element-118" />
                  </div>
                  <div data-id="element-119">
                    <p className="font-medium text-white" data-id="element-120">Matías D.</p>
                    <p className="text-sm text-gray-400" data-id="element-121">29 años, Neuquén</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}